<template>
	<div>
		<v-row no-gutters class="editor_top_bar" style="height: 70px; background: #fcfcfd; z-index: 3">
			<v-col cols="12">
				<BlockEditorTopHeader :showParams="true" :integrationSelector="false" headerIcons="branches" />
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12">
				<BranchRules :hasEditPermissions="hasEditPermissions" />
			</v-col>
		</v-row>
	</div>
</template>

<script>
import BlockEditorTopHeader from '@/components/BlockEditor/BlockEditorTopHeader';
import BranchRules from './BranchRules';

export default {
	name: 'Branch',
	components: {
		BlockEditorTopHeader,
		BranchRules,
	},
	props: {
		hasEditPermissions: { type: Boolean },
	},
};
</script>

<style scoped></style>
